var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlanCancelPopUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 62,
    height: 53,
    viewBox: "0 0 62 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M481 159h729v315H481z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "109.9%",
    height: "122.9%",
    x: "-4.9%",
    y: "-8.6%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 9,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 10.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.595547634 0 0 0 0 0.599104196 0 0 0 0 0.608072917 0 0 0 0.0749830163 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "d",
    cx: 725,
    cy: 268,
    r: 24
  }), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    width: "125%",
    height: "125%",
    x: "-12.5%",
    y: "-12.5%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "f",
    width: 606,
    height: 374,
    rx: 4
  }), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    width: "113.9%",
    height: "122.5%",
    x: "-8.6%",
    y: "-5.6%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -10,
    dy: 21,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 10.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.195552213 0 0 0 0 0.199719936 0 0 0 0 0.210229846 0 0 0 0.477682474 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "h",
    cx: 24,
    cy: 24,
    r: 24
  }), /*#__PURE__*/React.createElement("filter", {
    id: "g",
    width: "125%",
    height: "125%",
    x: "-12.5%",
    y: "-12.5%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-695-235H745v891H-695z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-695 -235)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    stroke: "#A3A3A3",
    d: "M-183.5 33.5h209v1h-209z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.477,
    d: "M-695-237H745v1348H-695z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-695 -235)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#c)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#d"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-277 -76)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#e)",
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#g)",
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#h"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC300",
    d: "M27 32.5l-6.466 3.4 1.235-7.2-5.23-5.1 7.228-1.05L27 16l3.233 6.55 7.229 1.05-5.231 5.1 1.235 7.2z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(41 3)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#EE2E3D",
    stroke: "#EE2E3D",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M6.879 5.464l5.657 5.657-1.415 1.415-5.657-5.657z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M5.464 11.121l5.657-5.657 1.415 1.415-5.657 5.657z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanCancelPopUp);
export default __webpack_public_path__ + "static/media/plan-cancel-pop-up.b78758a56ffa9a0450d9e3b7a31b0037.svg";
export { ForwardRef as ReactComponent };